const blankToNull = require('./../../../utils').blankToNull

export function validate(record) {
  const errors = []
  if (!record.descricao) {
    errors.push({
      field: 'descricao',
      message: 'O campo descrição é obrigatório',
    })
  }
  if (!record.tipo) {
    errors.push({
      field: 'tipo',
      message: 'O campo tipo é obrigatório',
    })
  }

  blankToNull(record)
  const result = {
    ok: errors.length === 0,
    errors,
    record,
  }
  return new Promise((resolve, reject) => {
    const action = result.ok ? resolve : reject
    return action(result)
  })
}
